import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { GeneralService, ReportIssueData } from '@app/core/services/general.service';
import { EntityType } from '@app/shared/enums/enums';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-report-issue-button',
  standalone: true,
  imports: [MatButtonModule],
  providers: [GeneralService],

  templateUrl: './report-issue-button.component.html',
  styleUrl: './report-issue-button.component.scss',
})
export class ReportIssueButtonComponent implements OnInit, OnDestroy {
  private queryReportIssue: Subscription | undefined;

  @Input() entityType!: EntityType;
  @Input() entityId!: string;
  @Input() contactNumberWhatsapp: string | undefined;
  @Input() isInternalUser: boolean = false;

  constructor(private generalService: GeneralService) {}

  ngOnInit(): void {
    return;
  }

  reportIssue() {
    this.navigateToWhatsapp();

    const data: ReportIssueData = {
      entityType: this.entityType,
      entityId: this.entityId,
      isInternalUser: this.isInternalUser,
    };

    this.queryReportIssue = this.generalService.postApiPublicMessageUs(data).subscribe();
  }

  ngOnDestroy(): void {
    this.queryReportIssue?.unsubscribe();
  }

  navigateToWhatsapp() {
    if (this.contactNumberWhatsapp) {
      const message: string = 'Hello, Regarding Enquiry ' + window.location.href + '\n';

      const encodedMessage: string = encodeURIComponent(message);

      const link: string = `https://wa.me/91${this.contactNumberWhatsapp}?text=${encodedMessage}`;

      window.open(link, '_blank');
    }
  }
}
